/**
 * După autentificare: hash în URL are prioritate, apoi home_shell din profil.
 */

import { state } from './core';
import { parseRouteHash, setRouteHash } from './deep-link';
import { navigateToSectionId } from './nav-bridge';
import { loadDashboard } from './overview';
import { openSpatialNavDemo } from './spatial-nav-demo';

export function applyInitialAppRoute(): void {
    const u = state.currentUser;
    if (!u?.username) return;

    if (u.must_change_password) {
        void loadDashboard();
        setRouteHash('dashboard');
        return;
    }

    const parsed = parseRouteHash();
    if (parsed?.kind === 'hub') {
        openSpatialNavDemo();
        setRouteHash('hub');
        return;
    }
    if (parsed?.kind === 'section') {
        const el = document.getElementById(`sec-${parsed.name}`);
        if (el) {
            navigateToSectionId(`sec-${parsed.name}`);
            setRouteHash(parsed.name);
            return;
        }
    }

    if (u.home_shell === 'hub') {
        openSpatialNavDemo();
        setRouteHash('hub');
    } else {
        void loadDashboard();
        setRouteHash('dashboard');
    }
}
